import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Chip } from '@flatfy/supernova-new';
import { FlatsFiltersContentContext } from '../FlatsFiltersContext';
import VisibilityOff from '../../icons/visibility-off.svg';
import { attachGaDataAttributes } from '../../helpers/analytics';

const FlatsFiltersSwitch = ({ filterParams: { name, checked } }) => {
  const { searchParams, updateSearchParams } = useContext(FlatsFiltersContentContext);
  const [isChecked, setIsChecked] = useState(checked !== null);

  const toggleSwitch = () => {
    updateSearchParams({
      ...searchParams,
      [name]: !isChecked ? true : null,
    });
  };

  useEffect(() => {
    setIsChecked(checked !== null);
  }, [checked]);

  return (
    <div className="FlatsFiltersSection">
      <Chip
        active={isChecked}
        onClick={toggleSwitch}
        icon={<VisibilityOff />}
        {...attachGaDataAttributes({
          category: window.eventCategory,
          action: 'filters',
          label: 'show_sold_click',
        })}
      >
        <FormattedMessage id="sold" />
      </Chip>
    </div>
  );
};

FlatsFiltersSwitch.propTypes = {
  filterParams: PropTypes.object.isRequired,
};

export default FlatsFiltersSwitch;
